import { createSelector } from '@reduxjs/toolkit';

const selectNodeSelectedIds = (state) => state.node?.selectedNodeIds ?? [];
const selectEdgeSliceIds = (state) => state.edge?.selectedEdgeIds ?? [];
const selectNodeEdgeIds = (state) => state.node?.selectedEdgeIds ?? [];
const selectNodes = (state) => state.node?.nodes ?? [];

const isInspectorlessDesignNode = (node) => {
  const symbolLabel = node?.data?.symbolLabel;
  return node?.type === 'boxNode'
    || node?.type === 'straightLineNode'
    || node?.type === 'symbolDrawerNode'
    || symbolLabel === 'Box'
    || symbolLabel === 'StraightLine'
    || symbolLabel === 'SymbolDrawer';
};

export const selectInspectorEnabled = createSelector(
  [selectNodeSelectedIds, selectEdgeSliceIds, selectNodeEdgeIds, selectNodes],
  (nodeIds, edgeSliceIds, nodeEdgeIds, nodes) => {
    const nodeCount = Array.isArray(nodeIds) ? nodeIds.length : 0;
    const uniqueEdges = new Set();

    if (Array.isArray(edgeSliceIds)) {
      edgeSliceIds.forEach((id) => uniqueEdges.add(id));
    }

    if (Array.isArray(nodeEdgeIds)) {
      nodeEdgeIds.forEach((id) => uniqueEdges.add(id));
    }

    if (nodeCount + uniqueEdges.size !== 1) {
      return false;
    }

    if (nodeCount === 1) {
      const selectedId = nodeIds[0];
      const selectedNode = Array.isArray(nodes)
        ? nodes.find((node) => node?.id === selectedId)
        : null;
      if (isInspectorlessDesignNode(selectedNode)) {
        return false;
      }
    }

    return true;
  }
);
